import { isEqual } from 'lodash';
import { IAppState, TActions } from '../../../common/state';
import { IJsonQuery } from '../../../json_query';
import { dealTypeFromJsonQuery, isParamAvailable, offerTypeFromJsonQuery } from '../../../utils/category';
import { getParams, IParams } from './params';

export function advancedReducer(state: IAppState, action: TActions): IAppState {
  if (
    action.type === 'filters/deal_type/DEAL_TYPE_CHANGED' ||
    action.type === 'filters/offer_type/OFFER_TYPE_SELECTED' ||
    action.type === 'filters/room/ROOM_CHANGED' ||
    action.type === 'filters/location_switcher/LOCATION_APPLIED' ||
    action.type === 'filters/garage/GARAGE_TYPE_CHANGED' ||
    (action.type === 'filters/advanced/TERMS_CHANGED' && action.key === 'placement_type')
  ) {
    const {
      config,
      filters: { jsonQuery, currentLocation },
    } = state;

    const dealType = dealTypeFromJsonQuery(jsonQuery);
    const offerType = offerTypeFromJsonQuery(jsonQuery);

    const params = getParams({ jsonQuery, currentLocation, config });
    const nextJsonQuery: IJsonQuery = (Object.keys(params) as (keyof IParams)[]).reduce((jQuery, key) => {
      const param = params[key];

      if (
        !isParamAvailable(dealType, offerType)(
          param.showCondition.dealType,
          param.showCondition.offerType,
          param.showCondition.custom,
        ) &&
        param.clearJsonQuery
      ) {
        return param.clearJsonQuery(jQuery);
      } else if (param.distinctJsonQuery) {
        return param.distinctJsonQuery(jQuery);
      }

      return jQuery;
    }, jsonQuery);

    if (!isEqual(jsonQuery, nextJsonQuery)) {
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: nextJsonQuery,
        },
      };
    }
  }

  return state;
}
